import { TaskDate } from 'src/core/master-data/domain/task-date';
import { LocalDate } from './local-date';
import { DateRange } from 'src/core/master-data/domain/date-range';
import * as moment from 'moment-timezone';

export class DateHelper {
  static expectedDate(date: TaskDate, expectedDateString: string = ''): string {
    const expected = date.expected;
    const from = date.range.from;
    const to = date.range.to;
    const rangeInSameDay = from.date.isSame(to.date, 'day');
    const showsHours = date.showsHours();

    if (rangeInSameDay) {
      if (!showsHours) {
        return `${expected.toFormat('DD/MM')}`;
      }
      const sameHour = from.toFormat('HH:mm') === to.toFormat('HH:mm');
      if (sameHour) {
        return `${expected.toFormat('DD/MM')} (${from.toFormat('H:mm')})`;
      }
      return `${expected.toFormat('DD/MM')} (${from.toFormat('H:mm')} - ${to.toFormat('H:mm')})`;
    }

    return showsHours
      ? `${from.toFormat('DD/MM H:mm')} - ${to.toFormat('DD/MM H:mm')} (${expectedDateString}: ${expected.toFormat(
          'DD/MM'
        )})`
      : `${from.toFormat('DD/MM')} - ${to.toFormat('DD/MM')} (${expectedDateString}: ${expected.toFormat('DD/MM')})`;
  }

  static thisWeekRange(): { from: string; to: string } {
    return DateRange.thisWeekRange().toYMDObject();
  }

  static thisMonthRange(): { from: string; to: string } {
    return DateRange.thisMonthRange().toYMDObject();
  }

  static lastMonthRange(): { from: string; to: string } {
    return DateRange.lastMonthRange().toYMDObject();
  }

  static threeMonthsBeforeAndAfterRange(): { from: string; to: string } {
    return DateRange.threeMonthsBeforeAndAfterRange().toYMDObject();
  }

  // Long, localized presentation for an ISO8601/atom datetime, e.g. "04 julio 2026 08:31".
  static formatLongDateTime(atom: string, locale: string): string {
    moment.locale(locale);
    const date = LocalDate.fromIsoString(atom);
    if (date === null) {
      return '';
    }

    return date.toFormat('DD MMMM YYYY HH:mm');
  }
}
